module.exports = __webpack_public_path__ + "img/2020-147_Stravenky-logoA-2025-07.54e39695.png";